var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{directives:[{name:"show",rawName:"v-show",value:(_vm.load),expression:"load"}],attrs:{"z-index":"999"}},[_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":"","size":"64"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }